import type { Components, Theme } from '@mui/material'

type MuiSelectSettings = Components<Omit<Theme, 'components'>>['MuiSelect']

export const MuiSelect: MuiSelectSettings = {
  defaultProps: {
    size: 'small',
    sx: { borderRadius: 2, borderColor: '#D5D7DA' },
  },
}
